import React from "react"
import { Box, Text } from "@singita/components"

export const Dates = ({ label, form, setForm, name, disabled }) => {
  return (
    <>
      {label && (
        <Box>
          <Text size="small" fontWeight="bold">
            {label}
          </Text>
        </Box>
      )}
    </>
  )
}
